import get from 'lodash/get';
import reduce from 'lodash/reduce';
import sortBy from 'lodash/sortBy';

export function groupData(list, sortKeysHashMap, sameFunc, diffFunc) {
  const keys = Object.keys(sortKeysHashMap);
  const sorted = sortBy(list, keys);

  return reduce(
    sorted,
    (acc, curr) => {
      const previous = get(acc, `[${acc.length - 1}]`, {});
      let isSame = true;

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (previous[sortKeysHashMap[key]] !== curr[key]) {
          isSame = false;
          // TODO: check if the break is working well (not here before)
          break;
        }
      }

      return isSame ? sameFunc(acc, curr) : diffFunc(acc, curr);
    },
    []
  );
}
